import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {AGAIA_WEB_ACCESS, unauthenticatedEntryRoute} from '../config/agaia-web-access.config';
import {AuthService} from '../services/auth.service';

@Injectable()
export class WebRegistrationClosedGuard implements CanActivate {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!AGAIA_WEB_ACCESS.webRegistrationDisabled) {
            return true;
        }

        if (this.authService.userHasLoggedIn) {
            return this.router.navigate(['dashboard']);
        }

        return this.router.navigate([unauthenticatedEntryRoute()]);
    }
}
